import React from 'react';

class Week extends React.Component {

    renderDays() {
        var days = [];
        var date = this.props.date;
        var month = this.props.month;
        var week = date.week();
        var disableBefore = this.props.disableBefore || null;
        days.push(
            <span key={"week-" + week} className={"week-nr"}>{week}</span>
        );
        for (var i = 0; i < 7; i++) {
            const day = {
                name: date.format("dd").substring(0, 1),
				number: date.date(),
				isCurrentMonth: date.month() === month.month(),
                isPrevMonth: date.month() < month.month(),
                isNextMonth: date.month() > month.month(),
				isToday: date.isSame(new Date(), "day"),
				date: date,
                disabled: disableBefore ? date < disableBefore : null
            };
            const onClick = day.disabled ? e => e.preventDefault() : this.props.select.bind(null, day);
            days.push(
                <span key={day.date.toString()} onClick={onClick} className={"day"
                + (day.isToday ? " today" : "")
                + (day.isCurrentMonth ? "" : " different-month")
                + (day.disabled ? " disabled" : "")
                + (this.props.selected.indexOf(day.date.format('YYYY-MM-DD')) > -1 ? " selected" : "")}>
                    {day.number}
                </span>
            );
            date = date.clone();
            date.add(1, "d");
        }

        return days;
    }

    render() {
        return (
            <div className="calendar-week">
                {this.renderDays()}
    		</div>
        );
    }
}
export default Week;



/** WEBPACK FOOTER **
 ** ./app/src/components/Form_widgets/Calendar/Week.js
 **/